export default __webpack_public_path__ + "static/media/reactNative.6cb55e18.jpg";